module.exports = __webpack_public_path__ + "static/media/bry.fca993fc.mp3";